const MultiPolicies = {
  HOL: "policies",
  MOL: "plans"
};

const PolicyLaspedGreaterThan3Years = {
  MOL:
    "As this plan has been lapsed for over 3 years, you are unable to access it online.",
  HOL:
    "As this policy has been lapsed for over 3 years, you are unable to access it online."
};

export { MultiPolicies, PolicyLaspedGreaterThan3Years };
